import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  useTheme,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface PaymentFailurePopupProps {
  open: boolean;
  onClose: () => void;
  message?: {
    error_code?: string | number;
    transaction_id?: string;
    auth_response_text?: string;
    [key: string]: any;
  };
}

const PaymentFailurePopup: React.FC<PaymentFailurePopupProps> = ({ open, onClose, message }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <ErrorOutlineIcon color="error" />
          <Typography variant="h6" color="error" fontWeight="bold">
            Payment Unsuccessful
          </Typography>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We couldn’t process your order. Please try again or contact support.
        </Typography>

        {message && (
          <Box
            sx={{
              p: 2,
              border: `1px solid ${theme.palette.error.main}`,
              borderRadius: 1,
              backgroundColor: theme.palette.error.light,
              color: theme.palette.error.contrastText,
              fontSize: '0.875rem',
              fontFamily: 'monospace',
            }}
          >
            {message.error_code && (
              <Typography sx={{ mb: 1 }}>
                <strong>Status Code:</strong> {message.error_code}
              </Typography>
            )}
            {message.transaction_id && (
              <Typography sx={{ mb: 1 }}>
                <strong>Transaction ID:</strong> {message.transaction_id}
              </Typography>
            )}
            {message.auth_response_text && (
              <Typography>
                <strong>Error Description:</strong> {message.auth_response_text}
              </Typography>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          sx={{
            mr: 2,
            mb: 1,
            px: 4,
            fontWeight: 'bold',
            textTransform: 'none',
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentFailurePopup;
